// extracted by mini-css-extract-plugin
module.exports = {"cardsList":"CardsList_cardsList__1ukn4","structureList":"CardsList_structureList__CNpaS"};